export default __webpack_public_path__ + "static/media/paths-icon.239abc8a.png";